import { useEffect, useContext, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Select, { components } from 'react-select';
import 'react-tabs/style/react-tabs.css';
import moment from 'moment/moment.js';
import { AppSettings } from '../../config/app-settings.js';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/id';

import Switch from "react-switch";
import { isEmpty } from "../../helper/helper.js"
import ModalWithProceed from '../../components/prompt/ModalWithProceed.jsx';

function AccountForm({ props = {} }) {
  const context = useContext(AppSettings);

  const [appData, setAppData] = useState({
    accountCouriers: []
  })
  const [promptIsOpen, setPromptIsOpen] = useState(false)

  const [formData, setFormData] = useState({
    mProvince: [],
    mCity: [],
    mDistrict: [],
    mSubDistrictPostalCode: [],
    mCustomer: [],
    mCourier: []
  });

  const [courierSetup, setCourierSetup] = useState({active: false})

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleOnChangeSwitch = async (c, e, id) => {
    setAppData(prevState => ({ ...prevState, [id]: c }))
  }

  const onChangeJsonFormat = async (e) => {
    const validJson = (e.jsObject === undefined) ? false : true;

    if (validJson) {
      setCourierSetup(prevState => ({
        ...prevState,
        jsonIsValid: (e.jsObject === undefined) ? false : true,
        attribute: e.jsObject ?? {},
        // uid: e.target.getAttribute('data-uid')
      }))
    } else {
      toast.error('Invalid JSON Format')
    }

  }

  // Custom Option component for the dropdown menu
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div>{props.data?.label} - <span className='fw-bold fs-6'>{props.data?.postalcode}</span></div>
      </components.Option>
    );
  };

  const onChangeProvince = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        province: option.value,
        provinceName: option.label,
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/city`, {
        params: { prov_code: option.value }
      }).then(async (res) => {
        const resp = res.data
        const cities = resp.data?.city;
        setFormData(prevState => ({ ...prevState, mCity: cities ?? [] }))
      }).catch(err => {
      })
    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        province: '',
        provinceName: '',
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mCity: [],
        mDistrict: [],
        mSubDistrictPostalCode: []
      }))
    }
  }

  const onChangeCity = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        city: option.value,
        cityName: option.label,
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/district`, {
        params: { city_code: option.value }
      }).then(async (res) => {
        const resp = res.data
        const districts = resp.data?.district;
        setFormData(prevState => ({ ...prevState, mDistrict: districts ?? [] }))
      }).catch(err => {
      })

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: [],
        mSubDistrictPostalCode: []
      }))
    }

  }

  const onChangeDistrict = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        district: option.value,
        districtName: option.label,
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/subdistrict`, {
        params: { district_code: option.value }
      }).then(async (res) => {
        const resp = res.data
        const subdistricts = resp.data?.subdistrict ?? [];
        setFormData(prevState => ({ ...prevState, mSubDistrictPostalCode: subdistricts ?? [] }))
      }).catch(err => {
      })

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: [],
        mSubDistrictPostalCode: []
      }))
    }

  }

  const onChangeSubDistrictPostalCode = async (option, e) => {

    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        subDistrict: option.value,
        subDistrictName: option.label,
        postalCode: option.postalcode
      }))

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        subDistrict: '',
        subDistrictName: '',
        postalCode: '',
      }))

    }
  }

  const onChangeSelectCourier = (e) => {
    const _uid = e.target.getAttribute('data-uid')

    const selectedIndex = appData.accountCouriers.findIndex(item => { return (item.uid ?? '-') === (_uid ?? '-') })
    if (selectedIndex > -1) {
      let couriers = appData.accountCouriers
      couriers[selectedIndex].courier = e.target.value

      setAppData(prevState => ({
        ...prevState,
        accountCouriers: couriers,
      }))

      setCourierSetup(prevState => ({
        ...prevState,
        courier: e.target.value,
      }))
    }

  }

  const addCourierSetupRow = async () => {
    const isNewRow = (appData.accountCouriers ?? []).filter((item) => { return (item.uid ?? '-') === '-' })

    if (isNewRow.length > 0) {
      return;
    }
    const rows = appData.accountCouriers
    rows.push({ uid: null, courier: null, active: true, attributes: {} })

    setAppData(prevState => ({
      ...prevState,
      accountCouriers: rows,
      selectedCodeCourierSetup: null,
      selectedIdCourierSetup: 0,
      selectedAttributesCourierSetup: {},
    }))

    setCourierSetup(prevState => ({
      ...prevState,
      attribute: {},
      uid: null,
      courier: null,
      active: true,
      updated_at: null,
      updated_by: null,
    }))

    /***
     * courier list only for non existing courier in account_courier_attributes
     */
    const c = [...new Set(appData.accountCouriers.filter(item => { return !isEmpty(item.uid) }).map(item => item.courier))];
    const cc = formData.mCourier.filter(item => !c.includes(item.value))

    setFormData(prevState => ({
      ...prevState,
      mCourier: cc
    }))
    
  }

  const selectCourierSetup = async (e) => {
    const uid = e.target.getAttribute('data-uid')

    if (!uid) {
      setCourierSetup(prevState => ({
        ...prevState,
        attribute: {},
        uid: null,
        courier: null,
        updated_at: null,
        updated_by: null,
      }))
      return;
    };

    await axios.get(`${window.API_HOST}/v1/account/account-courier/${uid}`)
      .then(res => {
        const data = res.data

        setCourierSetup(prevState => ({
          ...prevState,
          uid: uid,
          attribute: data.data?.attribute,
          courier: data.data?.courier,
          updated_at: data.data?.updated_at,
          updated_by: data.data?.updated_by ?? '',
        }))

      }).catch(err => {

      })

  }


  const handleOnChangeSwitchCourierSetup = async (c, e, id) => {
    const selectedIndex = appData.accountCouriers.findIndex(item => { return (item.uid ?? '-') === (id ?? '-') })
    if (selectedIndex > -1) {
      let couriers = appData.accountCouriers
      couriers[selectedIndex].active = c

      setAppData(prevState => ({
        ...prevState,
        accountCouriers: couriers,
      }))

      setCourierSetup(prevState => ({
        ...prevState,
        active: c
      }))
    }

  }

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      code: appData.accCode,
      name: appData.accName,
      shipperName: appData.shipperName,
      active: appData.active,
      address: appData.address ?? '',
      province: appData.province ?? '',
      provinceName: appData.provinceName ?? '',
      city: appData.city ?? '',
      cityName: appData.cityName ?? '',
      district: appData.district ?? '',
      districtName: appData.districtName,
      subDistrict: appData.subDistrict,
      subDistrictName: appData.subDistrictName,
      postalCode: appData.postalCode,
      phone: appData.phone,
      email: appData.email,
      taxNumber: appData.taxNumber,
      taxName: appData.taxName,
      billingPeriod: appData.billingPeriod,
      billingContact: appData.billingContact,
    }


    /**
     * check / validate data 
     */

    await axios.post(`${window.API_HOST}/v1/account`, payload).then(async (res) => {
      setAppData(prevState => ({
        ...prevState,
        uid: res.data?.uid
      }))
      toast.success(`Success save account ${appData.accName}`)
    }).catch(err => {
      toast.error(err.response.data?.error)
    })

  }

  const updateCourierSetup = async () => {

    if (isEmpty(courierSetup.courier)) {
      return
    }

    let payload = {
      active: courierSetup.active ?? false,
      courier: courierSetup.courier,
      attribute: courierSetup.attribute,
    }
 

    let couriers = appData.accountCouriers
    let selectedIndex =  couriers.findIndex(item => { return (item.uid ?? '-') === (courierSetup.uid ?? '-')}) 
    
    // new
    if (isEmpty(courierSetup.uid)) { 
      await axios.post(`${window.API_HOST}/v1/account/${props?.uid}/account-courier`, payload)
        .then(res => {
          const resp = res.data  

          couriers[selectedIndex].uid = resp?.data?.uid
          couriers[selectedIndex].updated_by = resp?.data?.updated_by
          couriers[selectedIndex].updated_at = resp?.data?.updated_at

          setAppData(prevState => ({
            ...prevState,
            accountCouriers: couriers,
          }))

          setCourierSetup(prevState => ({
            ...prevState,
            uid: resp?.data?.uid,
            courier: resp?.data?.courier,
            updated_by: resp?.data?.updated_by,
            updated_at: resp?.data?.updated_at
          }))

        })
        .catch(err => {

        })

    } else { 
      await axios.put(`${window.API_HOST}/v1/account/${props?.uid}/account-courier/${courierSetup.uid}`, payload)
        .then(res => {
          const resp = res.data 

          couriers[selectedIndex].uid = resp?.data?.uid
          couriers[selectedIndex].updated_by = resp?.data?.updated_by
          couriers[selectedIndex].updated_at = resp?.data?.updated_at

          setAppData(prevState => ({
            ...prevState,
            accountCouriers: couriers,
          }))

          setCourierSetup(prevState => ({
            ...prevState,
            uid: resp?.data?.uid,
            courier: resp?.data?.courier,
            updated_by: resp?.data?.updated_by,
            updated_at: resp?.data?.updated_at
          }))

        })
        .catch(err => {
          console.log(err.response.data)
          toast.error(err.response.data.error)

        })

    }

  }

  const confirmDeleteCourierSetup = async () => {
    setPromptIsOpen(false)

    if (isEmpty(courierSetup.uid) && isEmpty(courierSetup.courier)) {
      return
    }

    await axios.delete(`${window.API_HOST}/v1/account/account-courier/${courierSetup.uid}`, { data: {courier: courierSetup.courier} })
      .then(res => {
        const resp = res.data;

        const couriers = appData.accountCouriers
        const idx = couriers.map(e => e.id).indexOf(courierSetup.uid)
        couriers.splice(idx, 1);

        setAppData(prevState => ({
          ...prevState,
          accountCouriers: couriers
        }))

        setCourierSetup( prevState => ({
          ...prevState,
          uid: null, 
          courier: null,
          updated_by: null,
          updated_at: null
        }))

        toast.success(`Success delete courier ${courierSetup.courier}`)
      }).catch(err => {
        toast.error(err.response?.data?.error)
      })

  }

  const retrieveData = async () => {
    await axios.get(`${window.API_HOST}/v1/account/${props?.uid}`)
      .then(res => {
        const resp = res.data

        setAppData(prevState => ({
          ...prevState,
          accCode: resp?.data?.code,
          accName: resp?.data?.name,
          address: resp?.data?.address,
          province: resp?.data?.province,
          provinceName: resp?.data?.province_name,
          city: resp?.data?.city,
          cityName: resp?.data?.city_name,
          district: resp?.data?.district,
          districtName: resp?.data?.district_name,
          subdistrict: resp?.data?.subdistrict,
          subdistrictName: resp?.data?.subdistrict_name,
          postalCode: resp?.data?.postalcode,
          phone: resp?.data?.phone,
          email: resp?.data?.email,
          active: resp?.data?.active,
          accountCouriers: resp?.data?.accountCouriers ?? []
        }))

        setFormData(prevState => ({
          ...prevState,
        }))

        onChangeProvince({ value: resp?.data?.province, label: resp?.data?.province_name }, { action: "select-option" })
        onChangeCity({ value: resp?.data?.city, label: resp?.data?.city_name }, { action: "select-option" })
        onChangeDistrict({ value: resp?.data?.district, label: resp?.data?.district_name }, { action: "select-option" })
        onChangeSubDistrictPostalCode({ value: resp?.data?.subdistrict, label: resp?.data?.subdistrict_name, postalcode: resp?.data?.postalcode }, { action: "select-option" })
      }).catch(err => {

      })
  }

  useEffect(() => {

    //load ui data form
    async function fetchForm() {
      await axios.post(`${window.API_HOST}/ui/v1/form-account`)
        .then(res => {
          const data = res.data;
          setFormData(prevState => ({
            ...prevState,
            mProvince: data.provinces ?? [],
            mCourier: data.couriers ?? []
          }))
        }).catch(err => {

        })
    }

    fetchForm()
    if (!isEmpty(props?.uid)) {
      retrieveData()

    }
  }, []);

  return (
    <div className='m-0 p-0' >
      <Panel >
        <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
          <div className='row'>
            <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} Account</div>
            <div className='col-sm-6 align-items-baseline text-end'>
              <div className=''>
                {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
              </div>

            </div>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className="row" >
            <div className='col-sm-12'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Code</label>
                <div className="col-sm-8">
                  <input type="text" name="accCode" value={appData.accCode ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm"  disabled={props.uid} />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Name</label>
                <div className="col-sm-8">
                  <input type="text" name="accName" value={appData.accName ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row mb-10">
                <label className="col-sm-3 col-form-label">Active</label>
                <div className="col-sm-8">
                  <Switch id="active" name="active" onChange={handleOnChangeSwitch} checked={appData.active ?? false} />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <Tabs className="m-0 p-0 h-600px" style={{ 'width': '950px', }}>
              <TabList>
                <Tab><i className="fa fa-address-card"></i> Address</Tab>
                <Tab><i className="fa fa-cog"></i> General</Tab>
                <Tab><i className="fa fa-money-bill-alt"></i> Billing Information</Tab>

                <Tab><i className="fa fa-cog"></i> Rate Selection Criteria</Tab>
                {props.uid ? (
                  <Tab><span className="fa fa-link"></span> Courier Setup</Tab>
                ) : ''}

              </TabList>

              <TabPanel>
                <div className="row">
                  <div className='col-sm-12 bg-grey-transparent-1 pt-2'>
                    <div className="form-group row mb-1">
                      <div className="col-sm-12">
                        <textarea name="address"
                          onChange={handleOnChangeInputText} value={appData.address ?? ""}
                          className='form-control form-control-sm' placeholder="Address" ></textarea>
                      </div>
                    </div>
                    <div className="form-group row mb-1">
                      <div className="col-sm-6">
                        <Select name="province" placeholder={"Province"}
                          value={formData.mProvince.find(({ value }) => { return value === appData.province }) ?? ""}
                          options={formData.mProvince}
                          onChange={onChangeProvince}
                          isClearable={true} isSearchable={true} />
                      </div>
                      <div className="col-sm-6">
                        <Select name="city" placeholder={"City"}
                          value={formData.mCity.find(({ value }) => { return value === appData.city }) ?? ""}
                          options={formData.mCity}
                          onChange={onChangeCity}
                          isClearable={true} isSearchable={true} />
                      </div>
                    </div>
                    <div className="form-group row mb-1">
                      <div className="col-sm-6">
                        <Select name="district" placeholder={"District"}
                          value={formData.mDistrict.find(({ value }) => { return value === appData.district; }) ?? ""}
                          options={formData.mDistrict}
                          onChange={onChangeDistrict}

                          isClearable={true} isSearchable={true} />
                      </div>
                      <div className="col-sm-6">
                        <Select name="subDistrict" placeholder={"Sub District"}
                          value={formData.mSubDistrictPostalCode.find(({ value }) => { return value === appData.subDistrict }) ?? ""}
                          options={formData.mSubDistrictPostalCode}
                          onChange={onChangeSubDistrictPostalCode}
                          components={{ Option: CustomOption }}
                          isClearable={true} isSearchable={true} />
                      </div>
                    </div>
                    <div className="form-group row mb-1">
                      <div className="col-sm-6">
                        <input type="text" name="postalCode" value={appData.postalCode ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                      </div>
                      <div className="col-sm-6">
                        <input type="text" value={appData.originHub} onChange={() => { }} className="form-control form-control-sm bg-grey-transparent-1" readOnly={true} disabled />
                      </div>
                    </div>
                    <div className="form-group row mb-1">
                      <div className="col-sm-6">
                        <input type="text" name="phone" value={appData.phone ?? ""}
                          onChange={handleOnChangeInputText}
                          className="form-control form-control-sm" placeholder="Phone" />
                      </div>
                      <div className="col-sm-6">
                        <input type="text" name="email" value={appData.email ?? ""}
                          onChange={handleOnChangeInputText}
                          className="form-control form-control-sm" placeholder="Email" />
                      </div>
                    </div>
                  </div>

                </div>
              </TabPanel>
              <TabPanel>
                General
              </TabPanel>
              <TabPanel>
                <div className="row">
                  <div className='col-sm-6'>

                    <div className="form-group row m-b-3">
                      <label className="col-sm-3 col-form-label">Tax Number</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" name="taxNumber" value={appData.npwp ?? ""} onChange={handleOnChangeInputText}></input>
                      </div>
                    </div>
                    <div className="form-group row m-b-3">
                      <label className="col-sm-3 col-form-label">Tax Name</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" name="taxName" value={appData.npwpName} onChange={handleOnChangeInputText}></input>
                      </div>
                    </div>
                    <div className="form-group row m-b-3">
                      <label className="col-sm-3 col-form-label">Billing Period</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" name="billingPeriod" value={appData.billingPeriod} onChange={handleOnChangeInputText}></input>
                      </div>
                    </div>
                    <div className="form-group row m-b-3">
                      <label className="col-sm-3 col-form-label">Billing PiC</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" name="billingContact" value={appData.billingContact} onChange={handleOnChangeInputText}></input>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                Rate Selection Criteria
              </TabPanel>
              {props.uid ? (
                <TabPanel>
                  <div className="row m-0 p-0" >
                    <div className="col-sm-6 m-0 p-0">
                      <table className="table table-hover table-responsive m-0 p-0">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th className='w-200px'>Courier</th>
                            <th>Active</th>
                            <th><i className='fa fa-calendar-days' ></i></th>
                            <th><i className='fa fa-trash'></i></th>
                          </tr>
                        </thead>
                        <tbody>
                          {(appData.accountCouriers ?? []).map((val, key) => {
                            return (
                              <tr key={val.uid} className={((courierSetup.uid ?? '-') === (val.uid ?? '-') ? 'bg-blue-300' : '')}>
                                <td className='fs-11px'>{(key + 1)}.</td>
                                <td>
                                  <div className="input-group input-group-sm my-n1">
                                    <div className="input-group-text input-group-sm">
                                      <button className="btn btn-xs" key={`select-${val.uid}`} onClick={selectCourierSetup} data-uid={val.uid} data-courier={val.courier}><i className="fas fa-edit fa-fw" data-uid={val.uid} data-courier={val.courier}></i></button>
                                    </div>
                                    {(isEmpty(val.uid)) ?
                                      <select name="selectedCourierSetup" className="form-control form-control-xs" value={val.courier ?? ''}
                                        data-uid={val.uid}
                                        onChange={onChangeSelectCourier}
                                        disabled={!isEmpty(val.uid)}
                                      >
                                        <option value="">-</option>
                                        {formData.mCourier.map((courier, key) => {
                                          return (<option key={courier.value} value={courier.value}>{courier.label}</option>)
                                        })}
                                      </select> : <input type='text' className='form-control form-control-xs' value={val.courier ?? ''} disabled />}
                                  </div>
                                </td>
                                <td><Switch key={`active_${val.uid}`} id={val.uid} onChange={handleOnChangeSwitchCourierSetup} checked={val.active ?? false} disabled={!((courierSetup.uid ?? '-') === val.uid)} /></td>
                                <td><span className='d-inline-flex fs-11px'>{val.updated_at ? moment(val.updated_at).format("YYYY-MM-DD HH:mm") : "-"}</span></td>
                                <td>{((courierSetup.uid ?? '-') === val.uid) ? <button className="btn btn-xs btn-danger m-0" onClick={() => { setPromptIsOpen(true) }} key={val.uid} ><i className="fa fa-sm fa-trash" data-uid={val.uid} data-courier={val.courier}></i></button> : ''}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan={5}><button className="btn btn-sm btn-primary mt-2" onClick={addCourierSetupRow} >Add</button></td>
                            <td>&nbsp;</td>
                          </tr>
                          {/* <tr>
                            <td colSpan={5}>Selected: {appData.selectedIdCourierSetup} / {appData.selectedCodeCourierSetup}</td>
                          </tr> */}
                        </tfoot>
                      </table>
                    </div>
                    <div className="col-sm-6 m-0 p-0">
                      <div className="row row overflow-scroll m-0 p-0">
                        <div className="col-sm-12">
                          <strong>{courierSetup.courier ?? "-"}</strong> ,  updated by: {courierSetup.updated_by}
                          <JSONInput
                            data-uid={courierSetup.uid}
                            id='courierSetup'
                            name="courierSetup"
                            placeholder={courierSetup.attribute ?? {}}
                            value={courierSetup.attribute ?? {}}
                            onChange={onChangeJsonFormat}
                            colors={{
                              background: "rgba(182,194,201,.1)",
                              default: "black",
                              keys: "red"
                            }}
                            theme={"light_mitsuketa_tribute"}
                            locale={locale}
                            // onKeyPressUpdate={true}
                            waitAfterKeyPress={2500}
                            width={'auto'}
                            height='300px'
                          />

                        </div>
                        <div className='col-sm-12 my-2'>
                          <button className="btn btn-sm btn-primary me-5" onClick={updateCourierSetup}> <i className="fa fa-save"></i> Update</button>
                        </div>
                        <div>

                        </div>
                      </div>

                    </div>
                  </div>

                </TabPanel>
              ) : ''}
            </Tabs>
          </div>
        </PanelBody>
      </Panel>

      <ModalWithProceed header={false} show={promptIsOpen} close={() => { setPromptIsOpen(false) }} proceed={confirmDeleteCourierSetup}>
        Do you want to delete <strong>{courierSetup.courier}</strong> ?
      </ModalWithProceed>
    </div>

  )

}


export default AccountForm